module.exports = __webpack_public_path__ + "static/place-marker-1910d20c7554fe50d5905b905d9194f5.png";